import { useEffect, useRef } from 'react';
import { useContextSelector } from 'use-context-selector';
import _ from 'lodash';

import styles from './BookmarkDialog.module.scss';
import { UIContext } from '../context/UI/UIContext';
import Label from '../context/Label/Label';

type BookmarkDialogProps = {
  globalState: any;
  onDialogShow: () => void;
  onDialogHide: () => void;
};

function BookmarkDialog({
  globalState = {},
  onDialogShow,
  onDialogHide,
}: BookmarkDialogProps) {
  const { scorm, goPage, handleError } = globalState;
  const showConfirm = useContextSelector(UIContext, (c) => c.showConfirm);
  const hasCheckedBookmark = useRef<boolean>();
  hasCheckedBookmark.current = false;

  useEffect(() => {
    const { lessonLocation = {} } = scorm.initialScormData;

    if (!_.isEmpty(lessonLocation)) {
      // to avoid multiple calling (has to check only once)
      if (hasCheckedBookmark.current) return;
      hasCheckedBookmark.current = true;

      try {
        const lastVisitedPage = JSON.parse(lessonLocation)?.curPage;
        if (lastVisitedPage > 1) {
          const handleConfirm = (lastVisitedPage: number) => {
            goPage(lastVisitedPage);
            onDialogHide();
          };

          const handleCancel = () => {
            onDialogHide();
          };

          onDialogShow();
          showConfirm({
            description: <Label>Return to the last visited page?</Label>,
            onConfirm: () => handleConfirm(lastVisitedPage),
            onClickOutside: handleCancel,
            confirmLabel: <Label>yes</Label>,
            cancelLabel: <Label>no</Label>,
            confirmClassName: styles.bookmarkConfirmButton,
            cancelClassName: styles.bookmarkCancelButton,
          });
        }
      } catch (err) {
        console.error(err);
        handleError(new Error('Cannot parse lesson_location'));
        console.log({ lessonLocation });
      }
    }
  }, [scorm.scormReady, scorm.initialScormData]); // eslint-disable-line
  return null;
}

export default BookmarkDialog;
